/* Warm the article's actual offer document after reading starts, without executing its scripts. */
(function () {
  'use strict';
  var article = document.querySelector('.bpa');
  if (!article) return;
  var warmed = new Set();

  function constrainedConnection() {
    var connection = navigator.connection;
    return connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType || ''));
  }

  function warm(anchor) {
    if (!anchor || constrainedConnection() || document.visibilityState === 'hidden') return;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (error) { return; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
    if (!/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    url.hash = '';
    if (warmed.has(url.href) || warmed.size >= 2) return;

    var hint;
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      hint = document.createElement('script');
      hint.type = 'speculationrules';
      hint.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url.href], eagerness: 'immediate' }] });
    } else {
      hint = document.createElement('link');
      if (!hint.relList || !hint.relList.supports || !hint.relList.supports('prefetch')) return;
      hint.rel = 'prefetch';
      hint.as = 'document';
      hint.href = url.href;
      hint.fetchPriority = 'low';
    }
    warmed.add(url.href);
    hint.setAttribute('data-bp-offer-prefetch', '');
    document.head.appendChild(hint);
  }

  function warmFirstOffer() {
    warm(article.querySelector('a[data-bpa-cta]'));
  }

  function schedule() {
    if (constrainedConnection()) return;
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmFirstOffer, { timeout: 2000 });
    else window.setTimeout(warmFirstOffer, 800);
  }

  function intent(event) {
    var anchor = event.target.closest && event.target.closest('a[data-bpa-cta]');
    if (anchor && article.contains(anchor)) warm(anchor);
  }
  article.addEventListener('pointerover', intent, { passive: true });
  article.addEventListener('touchstart', intent, { passive: true });
  article.addEventListener('focusin', intent);
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
